import { render, staticRenderFns } from "./photoScan.vue?vue&type=template&id=286b8108&scoped=true"
import script from "./photoScan.vue?vue&type=script&lang=js"
export * from "./photoScan.vue?vue&type=script&lang=js"
import style0 from "./photoScan.vue?vue&type=style&index=0&id=286b8108&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b8108",
  null
  
)

export default component.exports